module.exports = __webpack_public_path__ + "static/media/smooth-white-plaster-wall.f5d00262.jpg";